import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { Row, Col } from "reactstrap"
import ContainerMax from "components/shared/ContainerMax"
import Text from "components/shared/Text"
import Social from "components/shared/Social"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import logo from "images/mado-logo.svg"

const ContainerMaxStyled = styled(ContainerMax)`
	text-align: center;
	a {
		color: ${props => props.theme.colors.white};
		font-family: ${props => props.theme.font.family.base};
		font-weight: ${props => props.theme.font.weight.regular};
		text-decoration: none;

		&:hover {
			color: ${props => props.theme.colors.white};
		}
	}

	img {
		max-width: 53.5%;
	}
`


const SocialWrap = styled.div`
	h5 {
		color: ${props => props.theme.colors.secondary};
		font-family: ${props => props.theme.font.family.bold};
		text-transform: uppercase;
		font-size: ${props => props.theme.font.size.sm};
		margin-bottom: .25rem;
	}
	ul {
		li {
			a {
				font-size: 1.25rem;
				padding: .5rem 1rem;
				color: ${props => props.theme.colors.white};
				text-decoration: none;
				
				&:hover {
					color: ${props => props.theme.colors.primary};
				}
				
				svg {
					max-height: 20px;
				}
			}
		}
	}
`


const FooterText = () => {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
				}
			}
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const { title } = data.site.siteMetadata
	const { footerText } = data.allWp.edges[0]?.node?.options?.acfOptions

	return (
		<ContainerMaxStyled>
			<img src={logo} alt={title} className="pt-4 pb-4" width="170"/>

			<Row>
				<Col>
					<SocialWrap className="pb-4">
						<Social />
					</SocialWrap>
				</Col>
			</Row>
			
			{footerText && 
				<Text $center $white $sm dangerouslySetInnerHTML={{ __html: LinkSearchReplace(footerText) }} />
			}
		</ContainerMaxStyled>
	)
}

export default FooterText